import * as R from 'ramda';
export default function Address(data) {
    let address = data || {};
    this.id = address.id;
    this.addressContract = address.addressContract === '0' ? undefined: address.addressContract ;
    this.addressLine1 = R.isNil(address.addressLine1) ? "" : address.addressLine1;
    this.addressLine2 = R.isNil(address.addressLine2) ? "" : address.addressLine2;
    this.addressType = address.addressType === '0' ? undefined: address.addressType;
    this.city = R.isNil(address.city) ? "" : address.city;
    this.country = R.isNil(address.country) ? 'FR' : address.country;
    this.phoneNumber = R.isNil(address.phoneNumber) ? "" : address.phoneNumber;
    this.postalCode = R.isNil(address.postalCode) ? "" : address.postalCode;
}